import React from 'react';
import Link from 'gatsby-link';

import navLogo from '../img/logo-white.png';

const Header = ({ siteTitle }) => (
  <div className="st-pusher">
    <div className="st-content">
      <div className="st-content-inner">
        <div className="header">
          <nav className="navbar navbar-expand-lg navbar--bold  navbar-transparent navbar-inverse bg-dark">
            <div className="container navbar-container">
              <Link className="navbar-brand" to="/">
                <img
                  src={navLogo}
                  className="d-none d-lg-inline-block nav-logo"
                  alt="Jamocha Media"
                />
                <img
                  src={navLogo}
                  className="d-lg-none nav-logo"
                  alt="Jamocha Media"
                />
              </Link>

              <div className="d-inline-block">
                <button
                  className="navbar-toggler hamburger hamburger-js hamburger--spring"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbar_main"
                  aria-controls="navbarsExampleDefault"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  style={{ color: 'white' }}
                >
                  <span className="hamburger-box">
                    <span className="hamburger-inner" />
                  </span>
                </button>
              </div>

              <div
                className="collapse navbar-collapse align-items-center justify-content-end"
                id="navbar_main"
              >
                <ul className="navbar-nav">
                  <li className="nav-item dropdown megamenu">
                    <Link className="nav-link" to="/brew-crew">
                      Brew Crew
                    </Link>
                  </li>
                  <li className="nav-item dropdown megamenu">
                    <Link className="nav-link" to="/writers">
                      Freelancers
                    </Link>
                  </li>
                  <li className="nav-item dropdown megamenu">
                    <Link className="nav-link" to="/faq">
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="pl-4 d-none d-lg-inline-block">
                <a
                  className="btn btn-styled btn-base-2 btn-circle"
                  href="https://www.ondelta.io/"
                >
                  JOIN OUR BOOTCAMP
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js